module.exports = __webpack_public_path__ + "static/media/Shopping.e4991026.svg";